export default {"src":"/_next/static/media/how-to-use-icon-1.c82ee965.svg","height":50,"width":68,"blurWidth":0,"blurHeight":0};